import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { componentViewEventAppDeclined, componentViewEventByViewName, componentViewEventFeedbackModal, componentViewEventGeneralError, componentViewEventPx, componentViewEventTimeout, getViewName } from "./rio";
import { getNotificationLabels } from "../../components/FeedbackModals/Notification/notification.utils";
import { EventTypes, recordEvents } from "../../utils/newRelic/newRelicEvents";
import { getTexts } from "../../utils/texts";
export { registerRouteChange };
function registerRouteChange(store) {
  var currentRoute = store.getState().router.current_route;
  var uuid = store.getState().authParams.uuid;
  handleRouteChange(currentRoute, uuid);
  return store.subscribe(function () {
    var state = store.getState();
    var route = state.router.current_route;
    var uuid = state.authParams.uuid;
    if (route !== currentRoute) {
      handleRouteChange(route, uuid);
      currentRoute = route;
    }
  });
}
function handleRouteChange(route, uuid) {
  var _getTexts;
  recordEvents(_defineProperty({}, EventTypes.mfaByAppRouteChange, {
    route: route
  }));

  //Note: mfa-by-email is not handled since it belongs to another package application
  switch (route) {
    default:
    case '/':
    case 'factor_selector':
      componentViewEventByViewName(getViewName(route), uuid);
      return;
    case 'qr':
      componentViewEventByViewName(getViewName(route), uuid);
      return;
    case 'timeout':
      componentViewEventTimeout(getViewName(route), uuid);
      return;
    case 'general_error':
      var footer = (_getTexts = getTexts()) === null || _getTexts === void 0 || (_getTexts = _getTexts.errorMessages) === null || _getTexts === void 0 || (_getTexts = _getTexts.generalError) === null || _getTexts === void 0 ? void 0 : _getTexts.footer;
      componentViewEventGeneralError(getViewName(route), footer, uuid);
      return;
    case 'push_sent':
      {
        var _getNotificationLabel = getNotificationLabels('notification_sent'),
          title = _getNotificationLabel.title;
        componentViewEventFeedbackModal(getViewName(route), title, uuid);
        return;
      }
    case 'app_push_declined':
      {
        var _getNotificationLabel2 = getNotificationLabels('app_push_declined'),
          _title = _getNotificationLabel2.title;
        componentViewEventAppDeclined(getViewName(route), _title, uuid);
        return;
      }
    case 'os_push_declined':
      {
        var _getNotificationLabel3 = getNotificationLabels('os_push_declined'),
          _title2 = _getNotificationLabel3.title;
        componentViewEventFeedbackModal(getViewName(route), _title2, uuid);
        return;
      }
    case 'px':
      {
        componentViewEventPx(getViewName(route), uuid);
        return;
      }
  }
}